import type { AppLanguage } from '@/shared/i18n/types';

import enFile from './en.json';
import jaFile from './ja.json';

const ja = (jaFile as { shopRegistrationComponents: any }).shopRegistrationComponents;
const en = (enFile as { shopRegistrationComponents: any }).shopRegistrationComponents;

export const shopRegistrationComponentsNamespaceResources: Record<AppLanguage, any> = {
  ja,
  en,
};